import { render, staticRenderFns } from "./AutomationEmailContent.vue?vue&type=template&id=bbe26d10&scoped=true&"
import script from "./AutomationEmailContent.vue?vue&type=script&lang=js&"
export * from "./AutomationEmailContent.vue?vue&type=script&lang=js&"
import style0 from "./AutomationEmailContent.vue?vue&type=style&index=0&id=bbe26d10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe26d10",
  null
  
)

export default component.exports